<template>
    <div class="row">
        <div class="col-md-3">
            <div class="info-box mb-3">
                <span class="info-box-icon bg-info elevation-1"
                    ><i class="fas fa-hospital"></i
                ></span>

                <div class="info-box-content">
                    <span class="info-box-text">ART Registered</span>
                    <span class="info-box-number">{{ totalART }}</span>
                </div>
                <!-- /.info-box-content -->
            </div>
        </div>
        <div class="col-md-3 offset-md-6">
            <div class="text-right">
                <select
                    v-model="year"
                    class="form-control"
                    @change="artCounters"
                >
                    <option v-for="(single, index) in years" :key="index">{{
                        single
                    }}</option>
                </select>
            </div>
        </div>
        <div class="col-md-12">
            <div class="card">
                <div id="chartdivARTRegistered"></div>
            </div>
        </div>
    </div>
</template>

<script>
// importing AMCharts
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
//default theme for AMcharts
am4core.useTheme(am4themes_animated);

export default {
    name: "city-wise-art-registered",
    data() {
        return {
            registration: null,
            year: 2021,
            totalART: null,
            years: [2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021]
        };
    },
    methods: {
        artCounters() {
            axios
                .post("cityWiseArtRegistered", { year: this.year })
                .then(response => {
                    console.log(response.data);
                    this.totalART = response.data[1];
                    this.populateCityWise(response.data[0]);
                })
                .catch(error => {
                    this.errored = true;
                })
                .finally(() => (this.loader = false));
        },
        populateCityWise(data) {
            am4core.ready(function() {
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                var chart = am4core.create(
                    "chartdivARTRegistered",
                    am4charts.XYChart
                );

                chart.data = data;
                chart.zoomOutButton.align = "left";
                chart.zoomOutButton.valign = "bottom";
                chart.zoomOutButton.parent = chart.tooltipContainer;
                chart.padding(40, 40, 40, 40);

                // Title
                let title = chart.titles.create();
                title.text = "ART Registered Clients City Wise";
                title.fontSize = 18;
                title.marginBottom = 30;

                var categoryAxis = chart.xAxes.push(
                    new am4charts.CategoryAxis()
                );
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.dataFields.category = "CityName";
                categoryAxis.renderer.minGridDistance = 60;
                categoryAxis.renderer.inversed = true;
                categoryAxis.renderer.grid.template.disabled = true;

                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;
                valueAxis.extraMax = 0.1;
                //valueAxis.rangeChangeEasing = am4core.ease.linear;
                //valueAxis.rangeChangeDuration = 1500;

                var series = chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.categoryX = "CityName";
                series.dataFields.valueY = "total";
                series.tooltipText = "{valueY.value}";
                series.columns.template.strokeOpacity = 0;
                series.columns.template.column.cornerRadiusTopRight = 10;
                series.columns.template.column.cornerRadiusTopLeft = 10;
                //series.interpolationDuration = 1500;
                //series.interpolationEasing = am4core.ease.linear;
                var labelBullet = series.bullets.push(
                    new am4charts.LabelBullet()
                );
                labelBullet.label.verticalCenter = "bottom";
                labelBullet.label.dy = -20;
                labelBullet.label.dx = 10;
                labelBullet.label.truncate = false;
                labelBullet.label.rotation = 270;
                labelBullet.label.text =
                    "{values.valueY.workingValue.formatNumber('#.')}";

                chart.zoomOutButton.disabled = true;

                // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
                series.columns.template.adapter.add("fill", function(
                    fill,
                    target
                ) {
                    return chart.colors.getIndex(target.dataItem.index);
                });

                categoryAxis.renderer.labels.template.rotation = 270;
                categoryAxis.renderer.labels.template.dx = -20;
                categoryAxis.renderer.minGridDistance = 1;

                // let categoryLabel = series.bullets.push(new am4charts.LabelBullet());
                // categoryLabel.label.text = "{CityName}";
                // categoryLabel.label.fontSize = 20;
                // categoryLabel.label.horizontalCenter = "right";
                // categoryLabel.label.dx = 0;
                // categoryLabel.label.fill = am4core.color("#000");
                // categoryLabel.label.dy = -50;
                // categoryLabel.label.rotation = 270;
                // categoryLabel.label.truncate = false;
                // categoryAxis.sortBySeries = series;
            }); // end am4core.ready()
        }
    },
    mounted() {
        this.artCounters();
    }
};
</script>

<style lang="scss" scoped>
#chartdivARTRegistered {
    width: 100%;
    height: 500px;
}
</style>
